import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import {
  IAddParticipantsPopupParams,
  useAddParticipantsPopupPresenter,
} from './AddParticipantsPopup.presenter';
import { ParticipantSelectList } from './ParticipantSelectList/ParticipantSelectList';

export const AddParticipantsPopup: FC<ICommonPopupsProps<IAddParticipantsPopupParams>> = (
  props
) => {
  const { t } = useTranslation();

  const presenter = useAddParticipantsPopupPresenter(props);

  if (!presenter.group) {
    return null;
  }

  return (
    <Popup
      title={t('add_people_screen_title')}
      isOpened={!!presenter.group}
      handlePrevStep={props.onBack ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <ParticipantSelectList
        group={presenter.group}
        onSuccess={presenter.onSuccess}
      />
    </Popup>
  );
};
